import { store } from '../index';
import axios from "axios";
import {
  TOKEN_KEY,
  CATEGORY_URL,
  ALL_ITEMS,
  ALL_ADDON,
  TENDER,
  GET_LABEL_TYPE,
  INVENTORY_URL,
  FOOD_INVENTORY_URL,
  CHECK_INVENTORY_STOCK
} from "./constant";

let optionAxios = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "x-api-source": "webapp",
  },
};


const get_inventory = async (input) => {
	let user = store.getState().sessionReducer || {};
	const {token, store_id} = user;
	input = { ...input, store_id};
	optionAxios.headers.authorization = token;
	return await axios
	.post(INVENTORY_URL, input, optionAxios)
	.then(function(resp) {
		return resp.data.data;

	})
	.catch((error) => {
    if(error?.response?.status === 401){
      window.location.href = "/rescan";
  }
	});
};

const get_food_inventory = async (input) => {
	let user = store.getState().sessionReducer || {};
	const {token, store_id} = user;
	input = { ...input, store_id};
	optionAxios.headers.authorization = token;
	return await axios
	.post(FOOD_INVENTORY_URL, input, optionAxios)
	.then(function(resp) {
		return resp.data.data;

	})
	.catch((error) => {
    if(error?.response?.status === 401){
      window.location.href = "/rescan";
  }
	});
};

const get_category = async ({ token, store_id } = {}) => {
  if (!token || !store_id) {
    console.log('[get_category] EXIT — missing token or store_id');
    return [];
  }
  const cacheKey = `MENU_CATEGORIES_ALL_${store_id}`;

  // Always fetch fresh category data (menu data may have been updated server-side)
  optionAxios.headers.authorization = token;
  return await axios
    .post(CATEGORY_URL, { store_id }, optionAxios)
    .then(function (resp) {
      const raw = resp.data.data;
      let allCategories = [];

      if (raw && typeof raw === "object" && !Array.isArray(raw)) {
        // New format: { "776": [...], "779": [...], ... } or { "776": { "data": [...] } }
        Object.entries(raw).forEach(([storeId, storeCats]) => {
          const categories = Array.isArray(storeCats)
            ? storeCats
            : Array.isArray(storeCats?.data)
            ? storeCats.data
            : Array.isArray(storeCats?.categories)
            ? storeCats.categories
            : [];
          categories.forEach((cat) => {
            allCategories.push({ ...cat, store_id: storeId });
          });
        });
      } else if (Array.isArray(raw)) {
        // Fallback: old flat array format
        allCategories = raw;
      }

      
      return allCategories;
    })
    .catch((error) => {
      console.error('[get_category] error', error?.response?.status, error?.message);
      if (error?.response?.status === 401) {
        window.location.href = "/rescan";
      }
      return [];
    });
};

const get_item_list = async ({ token, store_id } = {}) => {
  if (!token || !store_id) {
    console.log('[get_item_list] EXIT — missing token or store_id');
    return [];
  }
  // Backend returns items for ALL associated stores when called with the parent store_id
  optionAxios.headers.authorization = token;
  return await axios
    .post(ALL_ITEMS, { store_id }, optionAxios)
    .then(function (resp) {
      const raw = resp.data.data;
      let allItems = [];

      if (raw && typeof raw === "object" && !Array.isArray(raw)) {
        // New format: { "776": [...], "779": [...], ... }
        Object.entries(raw).forEach(([storeId, storeItems]) => {
          const items = Array.isArray(storeItems)
            ? storeItems
            : Array.isArray(storeItems?.data)
            ? storeItems.data
            : Array.isArray(storeItems?.items)
            ? storeItems.items
            : [];
          items.forEach((item) => {
            allItems.push({ ...item, store_id: storeId });
          });
        });
      } else if (Array.isArray(raw)) {
        // Fallback: old flat array format
        allItems = raw;
      }

      // Filter out items where available_on.web is explicitly false
      if (Array.isArray(allItems)) {
        allItems = allItems.filter((item) => {
          if (item?.available_on && item.available_on.web === false) {
            return false;
          }
          return true;
        });
      }

      
      return allItems;
    })
    .catch((error) => {
      console.error('[get_item_list] error', error?.response?.status, error?.message);
      if (error?.response?.status === 401) {
        window.location.href = "/rescan";
      }
      return [];
    });
};

const get_addon_list = async ({ token, store_id } = {}) => {
  if (!token || !store_id) {
    console.log('[get_addon_list] EXIT — missing token or store_id');
    return [];
  }
  const cacheKey = `MENU_ADDONS_${store_id}`;

  // Return cached addon data if available
  const cachedAddons = localStorage.getItem(cacheKey);
  if (cachedAddons) {
    try {
      return JSON.parse(cachedAddons);
    } catch (e) {
      localStorage.removeItem(cacheKey);
    }
  }

  optionAxios.headers.authorization = token;
  return await axios
    .post(ALL_ADDON, { store_id }, optionAxios)
    .then(function (resp) {
      const data = resp.data.data;
      
      return Array.isArray(data) ? data : [];
    })
    .catch((error) => {
      console.error('[get_addon_list] error', error?.response?.status, error?.message);
      if (error?.response?.status === 401) {
        window.location.href = "/rescan";
      }
      return [];
    });
};

const get_label_list = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  input = { ...input, store_id };
  const cacheKey = `MENU_LABELS_${store_id}`;

  // Return cached label data if available
  const cachedLabels = localStorage.getItem(cacheKey);
  if (cachedLabels) {
    try {
      return JSON.parse(cachedLabels);
    } catch (e) {
      localStorage.removeItem(cacheKey);
    }
  }

  optionAxios.headers.authorization = token;
  return await axios
    .post(GET_LABEL_TYPE, input, optionAxios)
    .then(function (resp) {
      const data = resp.data.data;
      
      return data;
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        window.location.href = "/rescan";
      }
    });
};

const get_tender = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  input = { ...input, store_id, source: "QR" };
  optionAxios.headers.authorization = token;
  return await axios
    .post(TENDER, input, optionAxios)
    .then(function (resp) {
      console.log(resp.data);

      return resp.data.data;
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        window.location.href = "/rescan";
      }
    });
};

// const get_api_details = async (input) => {
// 	let user = JSON.parse(localStorage.getItem('AUTH_DATA'));
// 	input = { ...input };
// 	optionAxios.headers.authorization = user.token;
// 	console.log(input);
// 	return await axios
// 		.post(GET_API_DETAILS, input, optionAxios)
// 		.then(function(resp) {
// 			console.log(resp.data);

// 			return resp.data.data;
// 		})
// 		.catch((error) => {
// 			console.log(error);
// 		});
// };

// const get_tax_list = async (input) => {
// 	let user = JSON.parse(localStorage.getItem('AUTH_DATA'));
// 	input = { ...input };
// 	optionAxios.headers.authorization = user.token;
// 	console.log(input);
// 	return await axios
// 		.post(GET_TAX, input, optionAxios)
// 		.then(function(resp) {
// 			console.log(resp.data);

// 			return resp.data.data;
// 		})
// 		.catch((error) => {
// 			console.log(error);
// 		});
// };
// const get_item_label = async (input) => {
// 	let user = JSON.parse(localStorage.getItem('AUTH_DATA'));
// 	input = { ...input };
// 	optionAxios.headers.authorization = user.token;
// 	console.log(input);
// 	return await axios
// 		.post(GET_ITEM_LABEL, input, optionAxios)
// 		.then(function(resp) {
// 			console.log(resp.data);
// 			return resp.data.data;
// 		})
// 		.catch((error) => {
// 			console.log(error);
// 		});
// };

// const get_tax = async (input) => {
// 	let user = JSON.parse(localStorage.getItem('AUTH_DATA'));
// 	input = { ...input };
// 	optionAxios.headers.authorization = user.token;
// 	console.log(input);
// 	return await axios
// 		.post(GET_TAX, input, optionAxios)
// 		.then(function(resp) {
// 			console.log(resp.data);
// 			return resp.data.data;
// 		})
// 		.catch((error) => {
// 			console.log(error);
// 		});
// };

// const get_modifier = async (input) => {
// 	let user = JSON.parse(localStorage.getItem('AUTH_DATA'));
// 	input = { ...input };
// 	optionAxios.headers.authorization = user.token;
// 	console.log(input);
// 	return await axios
// 		.post(GET_MODIFIER_GROUP, input, optionAxios)
// 		.then(function(resp) {
// 			console.log(resp.data);

// 			return resp.data.data;
// 		})
// 		.catch((error) => {
// 			console.log(error);
// 		});
// };

const check_inventory_stock = async (input) => {
	let user = store.getState().sessionReducer || {};
	const {token, store_id} = user;
	input = { ...input, store_id};
	optionAxios.headers.authorization = token;
	return await axios
	.post(CHECK_INVENTORY_STOCK, input, optionAxios)
	.then(function(resp) {
		return resp.data;
	})
	.catch((error) => {
    if(error?.response?.status === 401){
      window.location.href = "/rescan";
    }
    return error?.response?.data || { status: false, message: "Inventory check failed" };
	});
};

const update_local_storage_stock = (outOfStockItems, currentItemList, updateItemListRedux) => {
  try {
    const tokenData = store.getState().sessionReducer.token;
    if (!tokenData) return;
    const { user } = JSON.parse(tokenData);
    const loginStoreId = user?.store_id;
    if (!loginStoreId) return;

    let reduxItems = Array.isArray(currentItemList) ? [...currentItemList] : [];
    let updatedRedux = false;

    outOfStockItems.forEach(outItem => {
      const outSku = outItem.sku || outItem.item_sku || outItem.variant_sku;
      const outItemId = outItem.item_id || outItem._id;
      const outVariantId = outItem.variant_id || outItem.item_variant_id || outItem.variant_id_str;

      // Update redux items array
      reduxItems.forEach(item => {
        let itemMatched = false;
        if (outItemId && String(item._id) === String(outItemId)) {
          itemMatched = true;
        }
        if (outSku && String(item.sku) === String(outSku)) {
          itemMatched = true;
        }

        if (itemMatched) {
          item.is_stock = false;
          updatedRedux = true;
        }

        if (Array.isArray(item.item_variant)) {
          item.item_variant.forEach(variant => {
            let variantMatched = false;
            if (outVariantId && String(variant._id) === String(outVariantId)) {
              variantMatched = true;
            }
            if (outSku && String(variant.sku) === String(outSku)) {
              variantMatched = true;
            }

            if (variantMatched) {
              variant.is_stock = false;
              updatedRedux = true;
            }
          });

          const hasInStockVariant = item.item_variant.some(v => v.is_stock !== false);
          if (!hasInStockVariant) {
            item.is_stock = false;
            updatedRedux = true;
          }
        }
      });
    });

    if (updatedRedux) {
      if (typeof updateItemListRedux === "function") {
        updateItemListRedux(reduxItems);
      }
      
      // Also update the active store catalog since UI reads from catalogReducer
      store.dispatch({
        type: "CATALOG_LOAD_STORE",
        store_id: loginStoreId,
        items: reduxItems
      });
    }
  } catch (e) {
    console.error("Error in update_local_storage_stock:", e);
  }
};

const remove_out_of_stock_from_cart = (outOfStockItems, currentCartItems, removeItemFn, clearCartFn) => {
  try {
    const cartItems = Array.isArray(currentCartItems) ? currentCartItems : (store.getState().cartReducer?.addedItems || []);
    if (!cartItems || !cartItems.length) return;
    if (!Array.isArray(outOfStockItems) || !outOfStockItems.length) return;

    const itemsToRemove = cartItems.filter((cartItem) => {
      return outOfStockItems.some((outItem) => {
        const outItemId = outItem._id || outItem.item_id || outItem.id;
        const outSku = outItem.sku || outItem.item_sku || outItem.variant_sku;
        const outVariantId = outItem.variant_id || outItem.item_variant_id || outItem.variant_id_str;
        const outName = (outItem.item_name || outItem.name || "").trim().toLowerCase();

        const cartItemId = cartItem._id || cartItem.id || cartItem.item_id;
        const cartItemSku = cartItem.sku || cartItem.item_variant?.[0]?.sku;
        const cartItemName = (cartItem.item_name || "").trim().toLowerCase();

        if (outItemId && cartItemId && String(outItemId) === String(cartItemId)) return true;
        if (outSku && cartItemSku && String(outSku) === String(cartItemSku)) return true;
        if (outName && cartItemName && outName === cartItemName) return true;

        if (Array.isArray(cartItem.item_variant)) {
          const variantMatched = cartItem.item_variant.some((v) => {
            const vId = v._id || v.id || v.variant_id;
            const vSku = v.sku || v.variant_sku;
            const vName = (v.variant_name || v.name || "").trim().toLowerCase();
            if (outVariantId && vId && String(outVariantId) === String(vId)) return true;
            if (outSku && vSku && String(outSku) === String(vSku)) return true;
            if (outName && vName && outName === vName) return true;
            return false;
          });
          if (variantMatched) return true;
        }

        const allAddons = [
          ...(cartItem.selected_modifier || []),
          ...(cartItem.selectedAddonsItems || []),
          ...(cartItem.subItems || []),
          ...(cartItem.item_addons || [])
        ];
        const addonMatched = allAddons.some((addon) => {
          const aId = addon._id || addon.id || addon.item_id || addon.addon_id;
          const aSku = addon.sku || addon.addon_sku;
          const aName = (addon.item_name || addon.addon_name || addon.name || "").trim().toLowerCase();
          if (outItemId && aId && String(outItemId) === String(aId)) return true;
          if (outSku && aSku && String(outSku) === String(aSku)) return true;
          if (outName && aName && outName === aName) return true;
          return false;
        });
        if (addonMatched) return true;

        return false;
      });
    });

    if (itemsToRemove.length >= cartItems.length) {
      if (typeof clearCartFn === "function") {
        clearCartFn();
      } else {
        store.dispatch({ type: "CLEAR_CART" });
      }
    } else {
      itemsToRemove.forEach((item) => {
        if (typeof removeItemFn === "function") {
          removeItemFn(item);
        } else {
          store.dispatch({ type: "REMOVE_ITEM", item });
        }
      });
    }
  } catch (err) {
    console.error("Error in remove_out_of_stock_from_cart:", err);
  }
};

export {
  get_category,
  get_item_list,
  get_tender,
  get_addon_list,
  get_label_list,
  get_inventory,
  get_food_inventory,
  check_inventory_stock,
  update_local_storage_stock,
  remove_out_of_stock_from_cart
  // get_item_label,
  // get_api_details,
  // get_modifier,
  // get_tax_list,
  // get_tax
};
